/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  FundFactSheetResponse,
  NotFoundErrorResult,
  ResultOfReportObject,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    FundFactSheetResponseFromJSON,
    FundFactSheetResponseToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultOfReportObjectFromJSON,
    ResultOfReportObjectToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface PdfCheckFactSheetAvailabilityRequest {
    jseCode: string;
}

export interface PdfGetRelatedPartyDetailsPdfRequest {
    proposalId?: number;
}

export interface PdfGetStaticPdfRequest {
    pdf?: PdfGetStaticPdfPdfEnum;
}

/**
 * 
 */
export class PdfApi extends runtime.BaseAPI {

    /**
     * Downloads and serves a fund fact sheet PDF
     */
    async pdfCheckFactSheetAvailabilityRaw(requestParameters: PdfCheckFactSheetAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FundFactSheetResponse>> {
        if (requestParameters.jseCode === null || requestParameters.jseCode === undefined) {
            throw new runtime.RequiredError('jseCode','Required parameter requestParameters.jseCode was null or undefined when calling pdfCheckFactSheetAvailability.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/pdfs/factsheet/{jseCode}`.replace(`{${"jseCode"}}`, encodeURIComponent(String(requestParameters.jseCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FundFactSheetResponseFromJSON(jsonValue));
    }

    /**
     * Downloads and serves a fund fact sheet PDF
     */
    async pdfCheckFactSheetAvailability(requestParameters: PdfCheckFactSheetAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FundFactSheetResponse> {
        const response = await this.pdfCheckFactSheetAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Related Party Details PDF.
     */
    async pdfGetRelatedPartyDetailsPdfRaw(requestParameters: PdfGetRelatedPartyDetailsPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfReportObject>> {
        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/pdfs/related-parties-pdf`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfReportObjectFromJSON(jsonValue));
    }

    /**
     * Get Related Party Details PDF.
     */
    async pdfGetRelatedPartyDetailsPdf(requestParameters: PdfGetRelatedPartyDetailsPdfRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfReportObject> {
        const response = await this.pdfGetRelatedPartyDetailsPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Quote pdf.
     */
    async pdfGetStaticPdfRaw(requestParameters: PdfGetStaticPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.pdf !== undefined) {
            queryParameters['pdf'] = requestParameters.pdf;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/pdfs/static-pdfs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get Quote pdf.
     */
    async pdfGetStaticPdf(requestParameters: PdfGetStaticPdfRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.pdfGetStaticPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const PdfGetStaticPdfPdfEnum = {
    RelatedPartiesDetailsFormEnglish: 'RelatedPartiesDetailsFormEnglish',
    ControllingPersonSelfCertificationFormEnglish: 'ControllingPersonSelfCertificationFormEnglish',
    GuideForNoticeOfCessionFormEnglish: 'GuideForNoticeOfCessionFormEnglish',
    GuideForNoticeOfCessionFormAfrikaans: 'GuideForNoticeOfCessionFormAfrikaans',
    IdentificationOfAssociatedOrControllingPartiesEnglish: 'IdentificationOfAssociatedOrControllingPartiesEnglish',
    IdentificationOfAssociatedOrControllingPartiesAfrikaans: 'IdentificationOfAssociatedOrControllingPartiesAfrikaans',
    RequestForAdvanceGuaranteeEnglish: 'RequestForAdvanceGuaranteeEnglish',
    GlacierHubUserManualEnglish: 'GlacierHubUserManualEnglish',
    CancellationOfExistingFinancialProductsEnglish: 'CancellationOfExistingFinancialProductsEnglish',
    CancellationOfExistingFinancialProductsAfrikaans: 'CancellationOfExistingFinancialProductsAfrikaans',
    TaxW9FormEnglish: 'TaxW9FormEnglish',
    TaxW8BeneFormEnglish: 'TaxW8BENEFormEnglish',
    FinancialContributorThirdPartyFormBlank: 'FinancialContributorThirdPartyFormBlank',
    ActingOnBehalfThirdPartyFormBlank: 'ActingOnBehalfThirdPartyFormBlank',
    IndemnityFormBlank: 'IndemnityFormBlank',
    FicaAddendumForm: 'FICAAddendumForm',
    GlacierHubUserManualEnglishGaf: 'GlacierHubUserManualEnglishGAF'
} as const;
export type PdfGetStaticPdfPdfEnum = typeof PdfGetStaticPdfPdfEnum[keyof typeof PdfGetStaticPdfPdfEnum];
